import React, { FC } from 'react';
import { Box, Card, Grid } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { File as DenthubFile } from 'models/file';

type FileGridProps = {
    files: DenthubFile[];
    onDelete?: (fileId: string) => void;
};

const FileGrid: FC<FileGridProps> = ({ files, onDelete }: FileGridProps) => {
    return (
        <Grid container spacing={2}>
            {files.map((file) => (
                <Grid item key={file._id} xs={12} md={6} alignItems="center">
                    <Card variant="outlined" sx={{ height: '100%' }}>
                        <Box display="flex">
                            <Box display="flex" sx={{ height: 100, width: 100 }}>
                                {/image/.test(file.mimetype) ? (
                                    <img
                                        src={file.url}
                                        style={{
                                            height: 100,
                                            width: 100,
                                            padding: 6,
                                            objectFit: 'contain',
                                        }}
                                    />
                                ) : (
                                    <Box sx={{ fontSize: '90px', margin: 'auto' }}>
                                        <InsertDriveFileOutlinedIcon fontSize="inherit" />
                                    </Box>
                                )}
                            </Box>
                            <Box ml={2} display="flex" alignItems="center" flexGrow={1}>
                                <Box flexGrow={1} sx={{ overflowWrap: 'break-word' }}>
                                    {file.filename}
                                </Box>
                                {onDelete ? (
                                    <Box mr={1}>
                                        <IconButton
                                            onClick={() => onDelete(file._id as string)}
                                            aria-label="delete"
                                            size="large"
                                            data-test={`file-grid.delete-btn-${file._id}`}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                ) : undefined}
                            </Box>
                        </Box>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};
export default FileGrid;
